<template>
  <div class="container">
    <div class="row" v-if="step === 1">
      <div class="col-lg-3">
      </div>
      <div class="col-lg-6">
        <!-- <h2>Login</h2> -->
        <el-form v-loading="loading" id="postForm" ref="postForm" :model="postForm" :rules="rules" auto-complete="on" label-position="left">
          <p class="phone-input-label">You can enter your phone number below to review or cancel your reservation. </p>
          <el-form-item :error="p__errors.phone_number" label="" prop="phone_number">
            <br>
            <vue-tel-input
              :preferred-countries="preferred_countries"
              :only-countries="only_countries"
              :default-country="default_country"
              v-model="postForm.phone_number"
              @onInput="onInputPhone"
              @onValidate="onValidatePhone"/>
          </el-form-item>
          <div class="row">
            <div class="col-lg-12 text-right">
              <el-button type="primary" @click="sendVerificationCode">Send Text</el-button>
            </div><!-- end .col-lg-12 -->
          </div><!-- end .row -->
        </el-form>
      </div>
      <div class="col-lg-3">
      </div>
    </div><!-- end .row -->

    <div class="row" v-if="step === 2">
      <div class="col-lg-3">
      </div>
      <div class="col-lg-6">
        <!-- <h2>Login</h2> -->
        <el-form v-loading="loading" id="loginForm" ref="loginForm" :model="loginForm" :rules="loginRules" auto-complete="on" label-position="left">
          <p>Please check your phone and enter your verification code.</p>
          <el-form-item :error="p__errors.verification_code" label="" prop="verification_code">
            <br>
            <el-input v-model="loginForm.verification_code" type="text"/>
          </el-form-item>
          <div class="row">
            <div class="col-lg-12 text-right">
              <el-button type="primary"  @click="handleLogin">Confirm</el-button>
            </div>
          </div>
        </el-form>
      </div>
      <div class="col-lg-3">
      </div>
    </div>

  </div><!-- end .container -->
</template>

<script>
import { sendVerificationCode } from '@/api/user'
import VueTelInput from 'vue-tel-input'

/**
 * Form model initiated with the default value
 *
 */
const defaultForm = {
  phone_number: '',
}
const defaultLoginForm = {
  phone_isd: '',
  phone_number: '',
  step: 2,
  verification_code: '',
}
export default {
  name: 'Login',
  components: {
    VueTelInput
  },
  data() {
    return {
      loading: false,
      step: 1,
      p__errors: {
      },

      postForm: Object.assign({}, defaultForm),
      rules: {
        phone_number: {
          'required': true,
          'message': 'Please enter your phone number.',
          'trigger': 'blur',
        }
      },

      loginForm: Object.assign({}, defaultLoginForm),
      loginRules: {
        verification_code: {
          'required': true,
          'message': 'Please enter verification code.',
          'trigger': 'blur',
        }
      },
      redirect: undefined
    }
  },
  methods: {
    sendVerificationCode() {
      this.$refs.postForm.validate(valid => {
        if (valid) {
          this.loading = true
          this.postForm.step = 1
          sendVerificationCode(this.postForm).then(response => {
            this.loading = false
            if (response.data.success === true) {
              this.step = 2
            }
          }).catch(() => {
            this.loading = false
          })
        } else {
          this.p__errors.phone_number = 'Invalid phone number.'
          this.validationScrollTo('#postForm')
          return false
        }
      })
    },
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true
          this.loginForm.phone_isd = this.postForm.phone_isd
          this.loginForm.phone_number = this.postForm.phone_number
          this.$store.dispatch('user/LoginByPhone', this.loginForm).then(() => {
            this.loading = false
            this.$router.push({
              path: this.redirect || '/dashboard',
              query: this.otherQuery
            })
          }).catch(() => {
            this.loading = false
          })
        } else {
          this.p__errors.phone_number = 'Invalid phone number.'
          this.validationScrollTo('#loginForm')
          return false
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.container{
  margin-top: 80px;
  //height: calc(100vh - 196px);
}
.phone-input-label{
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// index.vue?819284f2